import { filterList } from 'utils/filterList';
import { useDebounce } from 'hooks/useDebounce';
import { useState, useMemo, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCatalogoMIState } from 'selectors/catalogMI.selector';
import { getCatalogoMI, updateCatalogoMI } from 'actions/catalogMI.actions';
import { downloadExcelCatalogoMI } from 'actions/files.actions';
import { Table, SelectTamanoPagina, Button, Tooltip, Modal, LoadingCard, Input } from 'components';
import { Col, Form, Row, message } from 'antd';
import { base64toBlob } from 'utils/file';
import Eliminar from 'assets/images/DeleteForever/delete_forever.svg';
import Editar from 'assets/images/Edit/edit_icon.svg';
import confirmarEliminar from '../../../../assets/images/eliminar_monitoreo.jpg';
import confirmarUpdate from '../../../../assets/images/imagen_message.png';
import { ReactComponent as InfoCircle } from '../../../../assets/images/InfoCircleExclamation/info_circle_exclamation.svg';
import './TablaCatalogo.scss';

const DEBOUNCE_TIME_FILTER = 1000;
export const TablaCatalogo = () => {
  const [form] = Form.useForm();
  const filtersRef = useRef({});
  const dispatch = useDispatch();
  const [loadingTable, setLoadingTable] = useState(false);
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const [filters, setFilters] = useState({});
  const [isOpenEliminar, setIsOpenEliminar] = useState(false);
  const [registroEliminar, setRegistroEliminar] = useState(null);
  const [confirmEliminar, setConfirmEliminar] = useState(false);
  const [confirmUpdate, setConfirmUpdate] = useState(false);
  const [msgSuccess, setMsgSuccess] = useState('');
  const [isFormModalVisible, setIsFormModalVisible] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);

  const [width, setWidth] = useState(null);
  const [height, setHeight] = useState(null);

  const { loading, data } = useSelector(selectCatalogoMIState);

  const applyFilter = useDebounce((fields) => setFilters(fields), DEBOUNCE_TIME_FILTER);

  useEffect(() => {
    dispatch(getCatalogoMI());
  }, []);

  const dataList = useMemo(() => {
    if (!data || Object.keys(data).length === 0) return [];
    return filterList(data, filters).map((item) => ({
      ...item,
      key: item.idTipoMedida
    }));
  }, [data, filters]);

  const showTotal = (total, range) => {
    if (total === 0) {
      setLoadingTable(false);
    }
    return `Mostrando del ${range[0]} al ${range[1]} de ${total} registros`;
  };

  const handleCloseModal = () => {
    setIsFormModalVisible(false); // Cerramos el modal
    setSelectedRow(null); // Quitamos los datos iniciales para el caso de edicion
    form.resetFields();
    setWidth(null);
    setHeight(null);
  };

  const existeElemento = (nuevoAncho, nuevoAlto) => {
    return data.some(
      (d) =>
        d.ancho - nuevoAncho === 0 &&
        d.alto - nuevoAlto === 0 &&
        d.idTipoMedida !== selectedRow?.tableRow?.idTipoMedida
    );
  };

  const mismoNombreMedida = (nombreMedida) => {
    return data.some((d) => d.nombreTipoMedida === nombreMedida);
  };

  const callAction = (clickedRow, actionType) => {
    if (actionType === 'edit') {
      setIsFormModalVisible(true);
      setSelectedRow({ tableRow: clickedRow, actionType });
      form.setFieldsValue({
        nombreTipoMedida: clickedRow?.tipoMedida,
        ancho: clickedRow?.ancho,
        alto: clickedRow?.alto
      });
      setWidth(clickedRow?.ancho);
      setHeight(clickedRow?.alto);
    }
  };
  const [pagination, setPagination] = useState({
    position: ['bottomRight'],
    showQuickJumper: true,
    size: 'small',
    pageSize: 10,
    current: 1,
    showTotal,
    total: 0,
    showSizeChanger: false
  });
  const handleDeleteMonitoring = (selected) => {
    setIsOpenEliminar(true);
    setRegistroEliminar(selected);
  };
  const cancelDelete = () => {
    setIsOpenEliminar(false);
    setRegistroEliminar(null);
  };
  const confirmDelete = async () => {
    const peticion = {
      toUpdate: [
        {
          idTipoMedida: registroEliminar.idTipoMedida,
          tipoMedida: registroEliminar.tipoMedida,
          ancho: registroEliminar.ancho,
          alto: registroEliminar.ancho,
          estatus: 0
        }
      ]
    };
    const { success } = await dispatch(updateCatalogoMI(peticion));
    if (success) {
      setConfirmEliminar(true);
      setIsOpenEliminar(false);
      setRegistroEliminar(null);
    }
  };

  const handleChangePageSize = (pageSize) => {
    setPagination((prevPagination) => ({ ...prevPagination, pageSize }));
  };
  const handleDownloadExcel = async () => {
    setDownloadingExcel(true);
    const { success, response } = await dispatch(
      downloadExcelCatalogoMI({ reporte_medidas: dataList })
    );
    if (response !== null && response !== undefined && success) {
      if (response.data.code === 200) {
        if (response.data.excel64) {
          const url = window.URL.createObjectURL(
            base64toBlob(response.data.excel64.base64, response.data.excel64.tipo)
          );
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', response.data.excel64.nombre);
          link.click();
          setDownloadingExcel(false);
        }
      }
    }
    setDownloadingExcel(false);
  };
  const handleChangeFilter = ({ target }) => {
    const { value, name } = target;
    filtersRef.current[name] = value;
    applyFilter({ ...filtersRef.current });
  };
  const handleOpenModal = () => {
    setIsFormModalVisible(true);
    form.resetFields();
  };
  const filter = (columnName, lblColumn) => (
    <label htmlFor={columnName}>
      {lblColumn}
      <Input
        id={columnName}
        placeholder="Filtrar"
        name={columnName}
        key={columnName}
        onChange={handleChangeFilter}
      />
    </label>
  );
  const handleCerrarSuccess = () => {
    setConfirmEliminar(false);
  };
  const handleUpdateCerrarSuccess = () => {
    setConfirmUpdate(false);
  };
  const onSave = async () => {
    try {
      const formEdit = await form.validateFields();
      if (!existeElemento(formEdit.ancho, formEdit.alto)) {
        if (!mismoNombreMedida(formEdit.nombreTipoMedida)) {
          const isNewRecord =
            selectedRow?.tableRow?.idTipoMedida === null ||
            selectedRow?.tableRow?.idTipoMedida === undefined;
          const body = isNewRecord
            ? {
                toSave: [
                  {
                    tipoMedida: formEdit.nombreTipoMedida,
                    ancho: formEdit.ancho,
                    alto: formEdit.alto
                  }
                ]
              }
            : {
                toUpdate: [
                  {
                    idTipoMedida: selectedRow?.tableRow?.idTipoMedida,
                    tipoMedida: formEdit.nombreTipoMedida,
                    ancho: formEdit.ancho,
                    alto: formEdit.alto,
                    estatus: 1
                  }
                ]
              };
          const { success } = await dispatch(updateCatalogoMI(body));
          if (success) {
            setMsgSuccess(
              isNewRecord ? 'Registro guardado exitosamente.' : 'Registro modificado exitosamente.'
            );
            setConfirmUpdate(true);
            setIsFormModalVisible(false);
            setSelectedRow(null); // Quitamos los datos iniciales para el caso de edicion
            form.resetFields();
            setWidth(null);
            setHeight(null);
          }
        } else {
          message.error('Ya existe un elemento con ese nombre.');
        }
      } else {
        message.error('Ya existe un elemento con esos valores de ancho y alto.');
      }
    } catch (error) {
      const { errorFields } = error;
      console.log(errorFields);
    }
  };
  const handleWidthChange = (e) => {
    const { value } = e.target;
    setWidth(value);
  };

  const handleHeightChange = (e) => {
    const { value } = e.target;
    setHeight(value);
  };
  const renderActions = (_, row, index) => (
    <div className="actions-container">
      <Tooltip title="Editar" className="tooltip-acciones btn-deleteoutlined" placement="topLeft">
        <Button
          type="primary"
          onClick={() => {
            callAction(row, 'edit', index);
          }}
          icon={<img src={Editar} alt="Editar" />}
          ghost
        />
      </Tooltip>

      <Tooltip title="Eliminar" className="tooltip-acciones btn-deleteoutlined" placement="topLeft">
        <Button
          shape="circle"
          className="btnTblAccion"
          icon={<img src={Eliminar} alt="Eliminar" />}
          onClick={() => {
            handleDeleteMonitoring(row);
          }}
        />
      </Tooltip>
    </div>
  );

  const columns = [
    {
      title: filter('idTipoMedida', 'ID del catálogo'),
      dataIndex: 'idTipoMedida',
      align: 'left',
      key: 'idTipoMedida',
      render: (_, record) => <div style={{ textAlign: 'center' }}>{record.idTipoMedida}</div>,
      width: '5%'
    },
    {
      title: filter('tipoMedida', 'Nombre del tipo de medida'),
      dataIndex: 'tipoMedida',
      width: '10%',
      key: 'tipoMedida'
    },
    {
      title: filter('medida', 'Medida'),
      dataIndex: 'medida',
      key: 'medida',
      width: '10%',
      render: (_, record) => (
        <div>
          {record.ancho} &times; {record.alto} cm
        </div>
      )
    },
    {
      title: 'Acciones',
      dataIndex: 'actions',
      align: 'center',
      width: '4%',
      key: 'actions',
      render: renderActions
    }
  ];
  return (
    <div className="tabla-catalogo">
      <Modal
        title={selectedRow ? 'Editar' : 'Agregar'}
        open={isFormModalVisible}
        width="50%"
        onCancel={handleCloseModal}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { marginLeft: '-1em' } }}
        okText="Guardar"
        onOk={onSave}
        centered>
        <div>
          <LoadingCard visible={loading} />
          {selectedRow?.tableRow?.idTipoMedida != null && (
            <div>
              <div>
                <span style={{ color: '#707070' }}>ID del catálogo: </span>
                <span style={{ color: '#648F9C' }}>{selectedRow?.tableRow?.idTipoMedida}</span>
              </div>
            </div>
          )}
          <div className="modal-formulario-subtitulo">
            <span className="container-description-form">
              <InfoCircle style={{ marginLeft: '10px', marginRight: '10px' }} />
              <span className="modal-formulario-subtitulo-descripcion">
                Captura la información solicitada.
              </span>
              <span className="modal-formulario-subtitulo-requeridos">*Campos obligatorios.</span>
            </span>
          </div>
          <Row>
            <Col span={14}>
              <Form layout="vertical" form={form}>
                <Form.Item
                  name="nombreTipoMedida"
                  label={<b>Nombre del tipo de medida:</b>}
                  rules={[{ required: true, message: 'Dato requerido.' }]}>
                  <Input placeholder="Escribe" style={{ width: '62%' }} />
                </Form.Item>
                <Form.Item
                  name="ancho"
                  label={<b>Ancho:</b>}
                  rules={[{ required: true, message: 'Dato requerido.' }]}>
                  <Row align="middle">
                    <Col span={15}>
                      <Input
                        type="number"
                        style={{ width: '100%' }}
                        placeholder="Escribe"
                        value={width}
                        onChange={handleWidthChange}
                      />
                    </Col>
                    <Col span={4} style={{ paddingLeft: '10px' }}>
                      <b>cm</b>
                    </Col>
                  </Row>
                </Form.Item>
                <Form.Item
                  name="alto"
                  label={<b>Alto:</b>}
                  rules={[{ required: true, message: 'Dato requerido.' }]}>
                  <Row align="middle">
                    <Col span={15}>
                      <Input
                        type="number"
                        style={{ width: '100%' }}
                        placeholder="Escribe"
                        value={height}
                        onChange={handleHeightChange}
                      />
                    </Col>
                    <Col span={4} style={{ paddingLeft: '10px' }}>
                      <b>cm</b>
                    </Col>
                  </Row>
                </Form.Item>
              </Form>
            </Col>
            <Col
              span={10}
              style={{
                textAlign: 'center',
                position: 'relative',
                padding: '20px 20px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="130"
                height="220.5"
                viewBox="0 0 179.944 220.5">
                <g transform="scale(0.8) translate(40, 40)">
                  <path
                    d="M40.889,131.111h73.778v18.444H40.889Zm0-36.889h73.778v18.444H40.889ZM96.222,2H22.444A18.5,18.5,0,0,0,4,20.444V168a18.42,18.42,0,0,0,18.352,18.444H133.111A18.5,18.5,0,0,0,151.556,168V57.333Zm36.889,166H22.444V20.444H87V66.556h46.111Z"
                    fill="#9159CB"
                  />
                </g>
                <line x1="30" y1="15" x2="150" y2="15" stroke="black" />
                <line x1="30" y1="5" x2="30" y2="25" stroke="black" />
                <line x1="150" y1="5" x2="150" y2="25" stroke="black" />{' '}
                {/* Líneas verticales de medida */}{' '}
                <line x1="15" y1="30" x2="15" y2="180" stroke="black" />
                <line x1="5" y1="30" x2="25" y2="30" stroke="black" />
                <line x1="5" y1="180" x2="25" y2="180" stroke="black" />{' '}
              </svg>
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '10px',
                  marginLeft: '-1em',
                  transform: 'translateY(-50%)',
                  color: '#c12b7d',
                  fontWeight: 'bold',
                  padding: '2px 5px'
                }}>
                {height} {height !== null ? 'cm' : 'Alto'}
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: '15px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: '#fff',
                  padding: '2px 5px',
                  fontWeight: 'bold',
                  color: '#c12b7d'
                }}>
                {width} {width !== null ? 'cm' : 'Ancho'}
              </div>
              <div
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: '210px',
                  transform: 'translateX(-50%)',
                  background: '#fff',
                  padding: '2px 5px',
                  color: 'skyblue',
                  fontWeight: 'bold'
                }}>
                {width !== null && height !== null ? `${width} x ${height} cm` : 'Medida'}
              </div>
            </Col>
          </Row>
        </div>
      </Modal>
      <div className="header-page">
        <div className="footer-page-pagination">
          <SelectTamanoPagina
            value={pagination.pageSize}
            onChange={handleChangePageSize}
            disableBottomExcel={downloadingExcel}
            onClick={handleDownloadExcel}
          />
        </div>{' '}
        <Button text="Agregar tipo   de medida" type="primary" onClick={handleOpenModal} />
      </div>
      <div className="table-container-catalogos">
        <Table
          bordered
          columns={columns}
          size="small"
          width="15%"
          dataSource={dataList}
          pagination={{
            ...pagination,
            onChange: (page, pageSize) => {
              setPagination((prev) => ({
                ...prev,
                current: page,
                pageSize: pageSize || prev.pageSize
              }));
            }
          }}
          loading={loading || loadingTable}
        />
      </div>
      <Modal
        open={isOpenEliminar}
        onCancel={cancelDelete}
        width="40em"
        cancelButtonProps={{ style: { marginRigth: '5em' } }}
        okButtonProps={{ style: { marginLeft: '5em' } }}
        okText="Aceptar"
        onOk={confirmDelete}
        handleCerrar={cancelDelete}>
        <div style={{ textAlign: 'center' }}>
          <h2>¿Deseas eliminar el registro?</h2>
        </div>
      </Modal>
      <Modal
        width="35em"
        open={confirmEliminar}
        title=""
        footer={null}
        onCancel={handleCerrarSuccess}>
        <div>
          <div style={{ marginTop: '30px', display: 'grid', justifyContent: 'center' }}>
            <img
              alt="example"
              style={{ width: '180px', marginLeft: '70px' }}
              src={confirmarEliminar}
            />
            <span className="modal-eliminar">Registro eliminado exitosamente.</span>
          </div>
        </div>
      </Modal>
      <Modal
        width="35em"
        open={confirmUpdate}
        title=""
        footer={null}
        onCancel={handleUpdateCerrarSuccess}>
        <div>
          <div style={{ margin: '30px', display: 'grid', justifyContent: 'center' }}>
            <img
              alt="example"
              style={{ width: '150px', marginLeft: '70px' }}
              src={confirmarUpdate}
            />
            <span className="modal-eliminar">{msgSuccess}</span>
          </div>
        </div>
      </Modal>
    </div>
  );
};
